module.exports = __webpack_public_path__ + "img/icon-ppt.0df36c24.png";